import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

import NavMotion from '@/components/layout/NavMotion'
import Loadable from '@/components/Loadable'
import MinimalLayout from '@/components/MinimalLayout'
import GuestGuard from '@/utils/guard/GuestGuard'

const AuthLogin = Loadable(lazy(() => import('@/pages/Login')))

const GuestRoutes = {
  path: '/',
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: '/login',
      element: <AuthLogin />,
    },
    {
      path: '*',
      element: <Navigate replace to={'/login'} />,
    },
  ],
}

export default GuestRoutes
